import { NgModule } from '@angular/core';
import { ExtraOptions, Routes, Router, RouterModule, NavigationError } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { environment } from '@environment';

import { filter } from 'rxjs/operators';

import { AuthGuard } from 'shared';
import { FeatureGuard } from 'shared';
import { BreadcrumbService } from 'shared';

import { HomeComponent } from './pages/home/home.component';
import { UsefulLinksComponent } from './pages/useful-links/useful-links.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { NoSitesComponent } from './pages/no-sites/no-sites.component';
import { StyleGuideComponent } from './pages/style-guide/style-guide.component';

const routes: Routes = [
    {
        path: '',
        canActivate: [ AuthGuard, FeatureGuard ],
        canActivateChild: [ AuthGuard, FeatureGuard ],
        children: [
            {
                path: 'unauthorized',
                component: UnauthorizedComponent,
                data: {
                    label: 'Unauthorized',
                }
            }, {
                path: '',
                component: HomeComponent,
                data: {
                    label: 'Home',
                    menuOrder: 1
                }
            }, {
                path: 'useful-links',
                component: UsefulLinksComponent,
                data: {
                    label: 'Useful Links',
                    menuOrder: 2,
                }
            }, {
                path: 'style-guide',
                component: StyleGuideComponent,
                data: {
                    label: 'Style Guide',
                    menuOrder: 3,
                    roles: [ 'developers' ]
                }
            }
        ]
    }, {
        path: 'no-sites',
        component: NoSitesComponent,
        data: {
            label: 'No Sites Available'
        }
    }, {
        // The following three routes are required for MSAL redirects
        path: 'code',
        component: HomeComponent
    }, {
        path: 'error',
        component: HomeComponent
    }, {
        path: 'state',
        component: HomeComponent
    }
];

const routeSettings: ExtraOptions = {
    enableTracing: !environment.isProduction,
    useHash: true
};

if (window !== window.parent && !window.opener)
    routeSettings.initialNavigation = 'disabled';
else
    routeSettings.initialNavigation = undefined;

@NgModule({
    imports: [
        RouterModule.forRoot(routes, routeSettings)
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
    constructor(private router: Router, private title: Title, private breadcrumbService: BreadcrumbService) {
        this.breadcrumbService.Breadcrumbs.subscribe(breadcrumbs => {
            const t = breadcrumbs.reduce((aggregate, current) => aggregate ? `${aggregate} / ${current.label}` : current.label, '');

            this.title.setTitle(`Vision - ${t}`);
        });

        this.router.events.pipe(filter(evt => evt instanceof NavigationError)).subscribe((event: NavigationError) => {
            console.error('Navigation Error');
            console.error({ event });
        });
    }
}
